export default {
  namespaced: true,

  state: {
    searchMode: 'routeinfo',
    activeTab: 'info',


  },

  mutations: {
    setSearchMode(state, navItem) {
      const {name, mode} = navItem;

      state.activeTab = name;
      state.searchMode = mode;
    }
  },

  getters: {},
}
